var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    staticClass: "mb-10"
  }, [!_vm.loading && !_vm.showSuccess && !_vm.showError ? _c('oloc-confirmation-screen', {
    key: 'confirmation',
    attrs: {
      "policy": _vm.policy,
      "continue-button-action": _vm.confirmPlan,
      "metadata": _vm.metadata,
      "member-profile": _vm.memberProfile
    },
    on: {
      "showThisDisclosure": _vm.showThisDisclosure
    }
  }) : _vm._e(), _vm._v(" "), _c('loading-overlay', {
    attrs: {
      "wait-for": _vm.loading,
      "reason": "Just one moment",
      "tracking": {
        class: 'members-area-oloc',
        subclass: 'page'
      },
      "light": true
    }
  }), _vm._v(" "), _c('disclosure-modal', {
    attrs: {
      "show": _vm.showDisclosure,
      "disclosure": _vm.disclosureFile,
      "metadata": _vm.metadata
    },
    on: {
      "close": _vm.viewedDisclosure
    }
  }), _vm._v(" "), !_vm.loading && _vm.showSuccess ? _c('div', {
    staticClass: "flex flex-col items-center absolute status-screen success-screen",
    class: {
      visible: _vm.showSuccessFadeIn
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "mb-4"
  }, [_vm._v("You're all set!")]), _vm._v(" "), _c('div', [_vm._v("Thank you for acknowledging our new agreements.")])]) : _vm._e(), _vm._v(" "), !_vm.loading && _vm.showError ? _c('div', {
    staticClass: "flex flex-col items-center absolute status-screen"
  }, [_vm._m(1), _vm._v(" "), _c('h2', {
    staticClass: "mb-4"
  }, [_vm._v("An error occurred")]), _vm._v(" "), _c('div', [_vm._v("Please close this window and try again.")])]) : _vm._e()], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "success-icon mb-8"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/check-success.svg")
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mb-8"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/warn_orange.svg")
    }
  })]);
}];
export { render, staticRenderFns };